<script lang="ts" setup>
const { t } = useI18n();
const img = useImage();
</script>

<template>
  <div class="SectionPricing">
    <div class="SectionPricing__row">
      <div
        class="SectionPricing__cell SectionPricing__cell--image"
        :style="`background-image: url(${img('/img/sluzby-photo-1.jpg', {
          width: 768,
        })})`"
      ></div>
      <div class="SectionPricing__cell">
        <h2 class="h2" style="margin: 0"> {{ t('SectionPricing.ourServices') }} </h2>
        <table class="SectionPricing__pricingTable">
          <tr>
            <td class="h4"> {{ t('SectionPricing.refreshSides') }} </td>
            <td class="link" style="text-align: right">400kč</td>
          </tr>
          <tr>
            <td class="h4"> {{ t('SectionPricing.classicCut') }} </td>
            <td class="link" style="text-align: right">650kč</td>
          </tr>
          <tr>
            <td class="h4"> {{ t('SectionPricing.hairAndBeard') }} </td>
            <td class="link" style="text-align: right">1000kč</td>
          </tr>
          <tr>
            <td class="h4"> {{ t('SectionPricing.exclusiveCare') }} </td>
            <td class="link" style="text-align: right">1 400Kč</td>
          </tr>
          <tr>
            <td class="h4"> {{ t('SectionPricing.beardTrim') }} </td>
            <td class="link" style="text-align: right">500Kč</td>
          </tr>
        </table>
        <strong
          class="display"
          style="text-transform: uppercase; font-size: 24px; font-weight: 700"
          > {{ t('SectionPricing.discount') }}
          <small> {{ t('SectionPricing.notForRefresh') }} </small></strong
        >
      </div>
    </div>
    <div class="SectionPricing__row SectionPricing_inverseFlex">
      <div class="SectionPricing__cell">
        <strong
          class="display"
          style="
            display: block;
            font-size: 40px;
            text-align: center;
            font-weight: 700;
          "
          > {{ t('SectionPricing.promo') }} </strong
        >
      </div>
      <div
        class="SectionPricing__cell SectionPricing__cell--image"
        :style="`background-image: url('${img('/img/sluzby-photo-2.jpg', {
          width: 768,
        })}')`"
      ></div>
    </div>
  </div>
</template>

<style scoped>
.SectionPricing {
}
.SectionPricing__row {
  align-items: center;

  @media screen(sm) {
    display: flex;
  }
}
.SectionPricing__cell {
  padding: 60px 20px;

  @media screen(sm) {
    flex-basis: 50%;
    padding: 90px 40px;
  }
}

.SectionPricing_inverseFlex {
  display: flex;
  flex-direction: column-reverse;

  @media screen(sm) {
    flex-direction: row;
  }
}
.SectionPricing__cell--image {
  background-size: cover;
  background-position: center;
  align-self: stretch;
  aspect-ratio: auto 16 / 9;

  @media screen (sm) {
    aspect-ratio: auto 1480 / 2200;
    height: auto;
  }
}

.SectionPricing__pricingTable {
  width: 100%;
  border-spacing: 0;
  margin: 1em 0;
}
</style>
